import { useTheme } from '@mui/material/styles';
import { HighlightOff } from '@mui/icons-material';
import { formatToAmount } from '@qrios/frontend-library';

import locales from '../../../../../../../constants/locales';
import DetailsList from '../../../../../../common/details-list';
import DetailsFactory from '../../../../../../common/details-list/detailsFactory';

import { Operation } from './interfaces';

interface Props {
  operation: Operation;
}

const FailureOperation = ({ operation }: Props) => {
  const theme = useTheme();
  const { details } = operation;

  const error = details.failureCause ? { errorMessage: details.failureCause } : undefined;

  return (
    <DetailsFactory
      header={{
        icon: { component: HighlightOff, color: theme.palette.error.main },
        id: operation.id,
        date: operation.date,
        status: operation.status
      }}
      error={error}
      operationContent={
        <DetailsList
          items={[
            {
              label: locales.operation.label.creditAccountNumber,
              value: details.creditAccount.accountNumber
            },
            { label: locales.operation.label.creditBank, value: details.creditAccount.bankName },
            {
              label: locales.operation.label.purpose,
              value: details.purpose
            },
            {
              label: locales.operation.label.amount,
              value: formatToAmount(operation.amount.value)
            },
            {
              label: locales.operation.label.externalTransactionId,
              value: details.externalTransactionId
            },
            {
              label: locales.operation.label.cost,
              value: formatToAmount(operation.cost.value)
            }
          ]}
        />
      }
    />
  );
};

export default FailureOperation;
